export const campaign = Object.freeze({
  source: 'utm_source',
  medium: 'utm_medium',
  campaign: 'utm_campaign',
  content: 'utm_content',
  keyword: 'utm_keyword',
  channel: 'utm_channel',
  term: 'utm_term',
  email: 'email',
});

export const campaignAnalytics = Object.freeze({
  source: 'utm_source',
  medium: 'utm_medium',
  campaign: 'utm_campaign',
  content: 'utm_content',
  keyword: 'utm_keyword',
  channel: 'utm_channel',
  cmpid: 'utm_cmpid',
  adgid: 'utm_adgid',
  adid: 'utm_adid',
  cmptyp: 'utm_cmptyp',
  intent: 'utm_intent',
  term: 'utm_term',
  rtid: 'rtid',
  shareid: 'sharedid',
});

export const EMAIL = 'email';

export const PHONENUMBER = 'phoneNumber';

export const REFERRAL_QUERY_PARAM = 'r';

export const REFERRAL_QUERY_PARAM_1 = 'r1';

export const CATEGORY_DEEPLINK_KEY = 'category';

export const V2A_INCENTIVE_REFERRAL_SOURCE = 'V2A';

export const OFFER_CODE_PARAM = 'offer_code';

export const REFERRAL_TERMS =
  'https://www.varomoney.com/policy/referral-program/';
